import { getPage } from '../custom_api/api';
import { defaultParsedImages } from '../custom_api/drupal_node_conversion';
import { Jumbo } from '../custom_components/components/jumbo/jumboLayout';
export const fetchEventsOverviewJumboGeneric = (size)=>async ()=>{
        const page = await getPage('/activiteiten', '', ()=>null);
        const result = page == 'error' || page == 'loading' ? fallback(size) : {
            title: page.headerTitle,
            contents: page.description,
            imageUrlSmall: page.phImageUrlSmall,
            imageUrl: page.phImageUrl,
            imageUrlFallback: page.phImageUrl,
            imageUrlLarge: page.phImageUrlLarge,
            imageAlt: page.imageAlt,
            size,
            kind: 'activity-overview'
        };
        return {
            kind: 'result',
            value: result,
            status: 200
        };
    };
const fallback = (size)=>({
        title: 'Activiteiten',
        contents: '',
        imageStyles: defaultParsedImages,
        imageUrl: '',
        imageUrlFallback: '',
        imageUrlLarge: '',
        imageAlt: '',
        size,
        kind: 'activity-overview'
    });
export const renderGenericJumbo = (props)=>Jumbo({
        ...props
    });
